import { useEffect, useState } from 'react';
import { useAxios } from '../hooks/useAxios';
import { GetUserId } from './platform-userid';
import { Console } from './platform-api';

const WorkatoJWT = () => {
  const { data, error, loading, fetchNow } = useAxios();
  const [isFetching, setIsFetching] = useState(true);
  const [jwtData, setJwtData] = useState();
  const wid = window.localStorage.getItem('workatoId');

  useEffect(() => {
    if (loading) return;
    if (wid === undefined || wid === 'undefined') return;

    Console('w id: ', wid, 'log');

    if (isFetching) {
      let payload = {
        WK_USER_ID: wid,
      };

      fetchNow(`/api/platform/workatoToken`, 'POST', payload, false);
    }

    const Fetched = () => {
      setIsFetching(false);
      setJwtData(data?.access_token);
    };

    Fetched();
  }, [data, isFetching, fetchNow, loading, jwtData, wid]);

  if (error) {
    console.log('error', error);
    return null;
  }

  return jwtData;
};

export { WorkatoJWT };
